import { __assign } from "tslib";
import _ from 'lodash';
import { Item, GalleryItem } from '@wix/pro-layouts-old';
import { getResizeMediaUrl } from '@wix/photography-client-lib';
import { utils } from './utils';
function convertDtoToLayoutItem(dto) {
    var dtoMetadata = dto.metadata || dto.metaData;
    var metadata = _.isObject(dtoMetadata)
        ? dtoMetadata
        : utils.parseStringObject(dtoMetadata) || {};
    return __assign({ id: dto.itemId || dto.photoId, width: metadata.width, height: metadata.height }, dto);
}
function getItemScaleByContainerSize(item, _a) {
    var width = _a.width, height = _a.height;
    var ratio = width / height;
    var cutByWidth = ratio > item.ratio;
    var scaleHeight = item.height / height;
    var scaleWidth = item.width / width;
    return cutByWidth ? scaleHeight : scaleWidth;
}
export function prepareFullscreenItem(_a) {
    var item = _a.item, itemIdx = _a.itemIdx, fullscreenSize = _a.fullscreenSize, styles = _a.styles, watermark = _a.watermark, scale = _a.scale, isExpandedView = _a.isExpandedView, isTouchDeviceZoom = _a.isTouchDeviceZoom, staticMediaUrls = _a.staticMediaUrls;
    var window_width = fullscreenSize.width;
    var window_height = fullscreenSize.height;
    var window_ratio = window_width / window_height;
    var itemResizer;
    if (watermark) {
        itemResizer = getResizeMediaUrl({ staticMediaUrls: staticMediaUrls, imageToken: watermark });
    }
    else {
        itemResizer = getResizeMediaUrl({ staticMediaUrls: staticMediaUrls });
    }
    // if (utils.isVerbose()) {
    // }
    // console.count('Preparing Fullscreen Item #' + itemIdx);
    var layoutItem = new Item({
        idx: itemIdx,
        dto: convertDtoToLayoutItem(item.dto || item),
        cubeImages: false,
        createdBy: 'prepareFullscreenItems',
    });
    // calc the fullscreen sizes
    var overScale = utils.isTouch() && layoutItem.isImage ? 3 : 1; // bring overscaled images to make sure it remains sharp when pinching
    if (layoutItem.ratio > window_ratio || utils.isMobile()) {
        layoutItem.resize((window_width / layoutItem.width) * overScale);
    }
    else {
        layoutItem.resize((window_height / layoutItem.height) * overScale);
    }
    layoutItem.width = Math.floor(layoutItem.width / overScale);
    layoutItem.height = Math.floor(layoutItem.height / overScale);
    var galleryItem = new GalleryItem({
        dto: layoutItem.dto,
        scheme: layoutItem.scheme,
        sharpParams: _.get(styles, 'sharpParams'),
        createMediaUrl: itemResizer,
    });
    var minScale = scale.min(galleryItem);
    if (!isTouchDeviceZoom) {
        galleryItem.height = Math.ceil(galleryItem.height * minScale);
        galleryItem.width = Math.ceil(galleryItem.width * minScale);
        if (!isExpandedView &&
            galleryItem.maxHeight &&
            galleryItem.maxWidth &&
            galleryItem.maxHeight > 1 &&
            galleryItem.maxWidth > 1) {
            galleryItem.height = Math.min(galleryItem.height, galleryItem.maxHeight);
            galleryItem.width = Math.min(galleryItem.width, galleryItem.maxWidth);
        }
        galleryItem.resetUrls();
    }
    galleryItem.preload_img =
        layoutItem.dto.preloadImg || galleryItem.createUrl('preload', 'thumb');
    return galleryItem;
}
export function prepareFullscreenItems(_a) {
    var srcItems = _a.srcItems, fullscreenSize = _a.fullscreenSize, styles = _a.styles, watermark = _a.watermark, galleryItems = _a.galleryItems, staticMediaUrls = _a.staticMediaUrls;
    if (utils.isVerbose()) {
        console.count('Preparing fullscreen items');
        console.time('Prepare fullscreen items');
    }
    var items = [];
    var item;
    var pointer = 0;
    var window_width = fullscreenSize.width;
    var window_height = fullscreenSize.height;
    var window_ratio = window_width / window_height;
    var itemResizer;
    if (watermark) {
        itemResizer = getResizeMediaUrl({ staticMediaUrls: staticMediaUrls, imageToken: watermark });
    }
    else {
        itemResizer = getResizeMediaUrl({ staticMediaUrls: staticMediaUrls });
    }
    item = srcItems[pointer];
    while (item) {
        // console.count('Preparing Fullscreen Item #' + item.idx);
        item = new Item({
            idx: item.idx,
            dto: convertDtoToLayoutItem(srcItems[pointer].dto || srcItems[pointer]),
            cubeImages: false,
            sharpParams: _.get(styles, 'sharpParams'),
            watermark: watermark,
            createdBy: 'prepareFullscreenItems',
        });
        // calc the fullscreen sizes
        var overScale = utils.isTouch() && item.isImage ? 3 : 1; // bring overscaled images to make sure it remains sharp when pinching
        if (item.ratio > window_ratio || utils.isMobile()) {
            // todo -  if (isNewFullscreen) {...........
            item.resize((window_width / item.width) * overScale);
        }
        else {
            item.resize((window_height / item.height) * overScale);
        }
        item.width = Math.floor(item.width / overScale);
        item.height = Math.floor(item.height / overScale);
        item = new GalleryItem({
            dto: item.dto,
            scheme: item.scheme,
            sharpParams: _.get(styles, 'sharpParams'),
            createMediaUrl: itemResizer,
        });
        var galleryItem = galleryItems && galleryItems[item.photoId];
        var useGalleryItem = galleryItem &&
            !galleryItem.cubeImages &&
            !(utils.isMobile() &&
                (galleryItem.resizeWidth > window_width ||
                    galleryItem.resizeHeight > window_height)); // on mobile, use the gallery image only if its smaller than the screen (must be a light image for smooth transitions
        item.preload_img = useGalleryItem
            ? galleryItem.createUrl('resized', 'thumb')
            : item.createUrl('resized', 'thumb');
        // populate the items array
        items.push(item);
        // advance the pointer
        pointer++;
        item = srcItems[pointer];
    }
    if (utils.isDev()) {
        console.timeEnd('Prepare fullscreen items');
    }
    return items;
}
//# sourceMappingURL=prepareFullscreenItems.js.map